import React from 'react';
import { CustomButton } from 'components';
import { ButtonType } from 'components/custom-button/CustomButton';
import { BackIcon } from 'assets/icons';
import { useNavigate } from 'react-router-dom';
import { VoidFn } from 'types/baseTypes';
import { useAppDispatch } from 'hooks';
import { resetEstimateState } from '../../estimatesSlice';

interface CreateEstimateHeaderProps {
  onSave: () => void;
  isEdit: boolean;
  isActionInProgress: boolean;
  onPreview: VoidFn;
}

const CreateEstimateHeader: React.FC<CreateEstimateHeaderProps> = ({
  onSave,
  isEdit,
  isActionInProgress,
  onPreview
}) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const handleBack = () => {
    navigate(-1);
    dispatch(resetEstimateState());
  };

  return (
    <div className="flex items-center justify-between border-b border-borderGray bg-white px-[30px] py-2.5">
      <div className="flex items-center">
        <BackIcon className="mr-4 cursor-pointer" onClick={handleBack} id="create-edit-estimate-back-button" />
        <h1 className="text-xl font-semibold">{isEdit ? 'Edit estimate' : 'New estimate'}</h1>
      </div>
      <div className="flex gap-5">
        <CustomButton
          onClick={onPreview}
          type={ButtonType.SECONDARY}
          id="create-edit-estimate-preview-button"
          className="px-6 py-2">
          Preview
        </CustomButton>
        <CustomButton
          isLoading={isActionInProgress}
          onClick={onSave}
          type={ButtonType.PRIMARY}
          id="create-edit-estimate-save-button"
          className="px-6 py-2">
          {isEdit ? 'Save' : 'Create'} & Share
        </CustomButton>
      </div>
    </div>
  );
};

export default CreateEstimateHeader;
